import React from "react";

const NormalPost = ({ commentaryData, timeOnly, displayCard }) => {
  const isZeroTime =
    (!commentaryData?.min || commentaryData?.min === 0) &&
    (!commentaryData?.pmin || commentaryData?.pmin === 0);

  return (
    <div className="normal_comm">
      <span className="cmntr_time">
        {isZeroTime ? (
          timeOnly
        ) : (
          <>
            {commentaryData?.min}
            {commentaryData?.pmin ? `+${commentaryData?.pmin}` : ""}
            &apos;
          </>
        )}
      </span>

      <span className="cmntr_icon">
        {["card", "sub", "goal"].includes(commentaryData?.type) &&
          displayCard(commentaryData?.com, commentaryData?.type)}
      </span>

      <span
        className="cmntr_icon_text"
        dangerouslySetInnerHTML={{ __html: commentaryData?.com }}
      />
    </div>
  );
};

export default NormalPost;
